<template lang="pug">
v-snackbar(
  :content-class="params.className"
  text
  v-model="snackbar"
  :top="true"
  :right="true"
  :timeout="6000")
  v-icon.mt-3 {{ getIcon }}
  | {{ message }}
  template(#action)
    v-btn(
      icon
      @click.native="snackbar = false")
      v-icon mdi-close

</template>

<script>
export default {

  name: 'AppNotify',

  data() {
    return {
      params: {
        text: '',
        className: '',
      },
      snackbar: false,
    };
  },

  computed: {
    message() {
      const message = this.params.text;
      return message;
    },
    getIcon() {
      return this.params.className.replace('snackbar-', '$');
    },
  },

  created() {
    this.$notify.$on('message', this.handleMessage);
  },

  beforeDestroy() {
    this.$notify.$off('message', this.handleMessage);
  },

  methods: {
    handleMessage(params) {
      this.snackbar = false;

      this.params = { ...this.params, ...params };

      setTimeout(() => {
        this.snackbar = true;
      }, 0);
    },
  },
};
</script>
